import "select2"

$(document).on 'turbolinks:load', ->
  return unless $('.strategic-statuses-reports').length > 0

  # Initialize Select2
  $('.select2-entities').select2
    theme: 'bootstrap4'
    allowClear: true


  $('.select2-state').select2
    theme: 'bootstrap4'
    allowClear: true

  $('.select2-city').select2
    theme: 'bootstrap4'
    allowClear: true

  # Strategic Status Groups change event
  $('#strategic_status_group_ids').on 'change', ->
    console.log('loaded?')
    selectedGroups = $(this).val()
    statusSelect = $('#report_strategic_status_ids')

    if selectedGroups && selectedGroups.length > 0
      statusSelect.prop('disabled', true).empty()

      # Load sub-statuses for each selected group
      loadPromises = []
      for groupId in selectedGroups
        promise = $.get '/strategic_statuses_reports/sub_statuses_by_parent',
          parent_id: groupId
        loadPromises.push(promise)

      # Wait for all requests to complete
      $.when.apply($, loadPromises).done (responses...) ->
        allStatuses = []
        
        # Handle single or multiple responses
        if loadPromises.length == 1
          allStatuses = responses[0]
        else
          for response in responses
            allStatuses = allStatuses.concat(response[0])

        # Remove duplicates
        uniqueStatuses = []
        seenIds = []

        for status in allStatuses
          if status.id not in seenIds
            seenIds.push(status.id)
            uniqueStatuses.push(status)

        # Populate select
        for status in uniqueStatuses
          statusSelect.append($('<option>',
            value: status.id
            text: status.name
          ))

        statusSelect.prop('disabled', false)
      .fail ->
        console.error('Error loading sub-statuses')
        statusSelect.prop('disabled', false)
    else
      statusSelect.prop('disabled', true).empty()

  # State change event
  $('#state').on 'change', ->
    state = $(this).val()
    citySelect = $('#city')

    # Reset dependent selects
    citySelect.empty().prop('disabled', true).select2('val', null)

    if state
      $.get '/strategic_statuses_reports/cities_by_state',
        state: state
      .done (cities) ->
        citySelect.append($('<option>',
          value: ''
          text: 'Selecione uma cidade'
        ))
        for city in cities
          citySelect.append($('<option>',
            value: city
            text: city
          ))
        citySelect.prop('disabled', false)
      .fail ->
        console.error('Error loading cities')

  # City change event
  $('#city').on 'change', ->
    state = $('#state').val()
    city = $(this).val()

  # Enable buttons on page load
  $('.btn-generate-excel, .btn-generate-pdf').prop('disabled', false)

  # Button click handlers
  $('.btn-generate-excel').on 'click', (e) ->
    e.preventDefault()
    console.log('Excel button clicked')
    window.lastClickedButton = $(this)
    $('#strategic-statuses-form').trigger('submit')

  $('.btn-generate-pdf').on 'click', (e) ->
    e.preventDefault()
    console.log('PDF button clicked')
    window.lastClickedButton = $(this)
    $('#strategic-statuses-form').trigger('submit')

  # Clear filters button
  $('.btn-clear-filters').on 'click', ->
    # Reset form
    $('#strategic-statuses-form')[0].reset()
    
    # Reset select2 elements
    $('.select2-entities').select2('val', null)
    $('.select-with-select2').select2('val', null)
    $('.select2-statuses').select2('val', null)
    $('.select2-state').select2('val', null)
    $('.select2-city').select2('val', null)

    # Disable dependent selects
    $('#strategic_status_ids').prop('disabled', true)
    $('#city').prop('disabled', true)

    # Note: Date fields are now cleared by the Stimulus controller

  # Variable to track which button was clicked
  window.lastClickedButton = null

  # Form submission
  $('#strategic-statuses-form').on 'submit', (e) ->
    e.preventDefault()
    
    console.log('Form submitted')
    
    # Show loading modal
    $('#loadingModal').modal('show')

    # Get the clicked button to determine the action
    clickedButton = window.lastClickedButton || $(document.activeElement)
    isPdf = clickedButton && clickedButton.hasClass('btn-generate-pdf')
    
    console.log('Clicked button:', clickedButton)
    console.log('Is PDF:', isPdf)
    
    # Create form data
    formData = $(this).serialize()
    console.log('Form data:', formData)

    # Submit via AJAX for file download
    xhr = new XMLHttpRequest()
    if isPdf
      xhr.open('POST', '/strategic_statuses_reports/generate_pdf', true)
    else
      xhr.open('POST', '/strategic_statuses_reports/generate_excel', true)
    xhr.responseType = 'blob'
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    
    xhr.onload = ->
      $('#loadingModal').modal('hide')
      
      if xhr.status == 200
        # Determine content type and filename based on request type
        if isPdf
          contentType = 'application/pdf'
          defaultFilename = 'relatorio_status_estrategicos.pdf'
        else
          contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          defaultFilename = 'relatorio_status_estrategicos.xlsx'
        
        # Create download link
        blob = new Blob([xhr.response], { type: contentType })
        url = window.URL.createObjectURL(blob)
        
        # Get filename from header or use default
        filename = defaultFilename
        disposition = xhr.getResponseHeader('Content-Disposition')
        if disposition && disposition.indexOf('filename=') != -1
          # Extract filename properly handling encoding
          filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if filenameMatch && filenameMatch[1]
            filename = filenameMatch[1].replace(/['"]/g, '')
            # Decode any URL encoding
            try
              filename = decodeURIComponent(filename)
            catch error
              console.log('Could not decode filename, using default')
              filename = defaultFilename

        # Trigger download
        a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      else if xhr.status == 422
        alert('Erro de autenticação. Por favor, recarregue a página e tente novamente.')
      else
        alert('Erro ao gerar relatório. Por favor, tente novamente.')
        
    xhr.onerror = ->
      $('#loadingModal').modal('hide')
      alert('Erro ao gerar relatório. Por favor, tente novamente.')
      
    xhr.send(formData) 